import { create } from 'zustand';

export interface GlobalAppState {
  // State
  showAccountInvitationModal: boolean;
  invitationPayload: any;
  currentPagePath: string;
  showInsufficientTokensModal: boolean;
  insufficientTokensHasActiveSubscription: boolean;
  
  // Actions
  setShowAccountInvitationModal: (show: boolean) => void;
  setInvitationPayload: (payload: any) => void;
  setCurrentPagePath: (path: string) => void;
  resetInvitation: () => void;
  setShowInsufficientTokensModal: (show: boolean) => void;
  setInsufficientTokensHasActiveSubscription: (hasActive: boolean) => void;
}

export const useGlobalAppStore = create<GlobalAppState>((set) => ({
  // Initial state
  showAccountInvitationModal: false,
  invitationPayload: null,
  currentPagePath: '',
  showInsufficientTokensModal: false,
  insufficientTokensHasActiveSubscription: false,
  
  // Actions
  setShowAccountInvitationModal: (show: boolean) => set({ showAccountInvitationModal: show }),
  setInvitationPayload: (payload: any) => set({ invitationPayload: payload }),
  setCurrentPagePath: (path: string) => set({ currentPagePath: path }),
  resetInvitation: () => set({ showAccountInvitationModal: false, invitationPayload: null }),
  setShowInsufficientTokensModal: (show: boolean) => set({ showInsufficientTokensModal: show }),
  setInsufficientTokensHasActiveSubscription: (hasActive: boolean) => set({ insufficientTokensHasActiveSubscription: hasActive }),
}));
